import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TextField from "@mui/material/TextField";
import { Controller } from "react-hook-form";
import { MenuItem } from "@mui/material";
const inputStyled = {
    "& .ck-editor__editable, & input, & textarea": {
        border: "none",
    },
    "& textarea": {
        pt: 0.5,
    },
    "& .MuiFormHelperText-root": {
        fontSize: { xs: "14px" },
    },
    "& .MuiFormLabel-root": {
        zIndex: 1,
        top: 20,
        left: 24,
        transition: "all 0.2s ease",
        "&.MuiInputLabel-root.Mui-focused": {
            top: 0,
            left: 0,
            transform: "translate(0, -1.5px) scale(1)",
        },
    },
};
// le padding du thème est sur la racine, hors de la zone cliquable du Select
const selectStyled = {
    "& .MuiInputLabel-root": {
        pointerEvents: "none",
    },
    "& .MuiInputBase-root": {
        p: 0,
    },
    "& .MuiInputBase-root .MuiSelect-select.MuiInputBase-input": {
        p: "20px 56px 20px 24px",
    },
    "& .MuiSelect-icon": {
        right: 14,
    },
};
const ContactTextField = ({ name, label, control, rules, showError, errors, onResetError, inputAdornmentError, type, multiline, selectOptions = [], rows, exampleText, }) => {
    const hasError = showError(name);
    // reste affiché pendant la saisie pour rappeler le format attendu
    const helperText = hasError ? errors[name]?.message : exampleText || "";
    const helperTextId = hasError
        ? `${name}-error`
        : exampleText
            ? `${name}-example`
            : undefined;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(TextField, { id: name, ...field, label: label, variant: "standard", error: hasError, helperText: helperText, onChange: (event) => {
                onResetError();
                field.onChange(event);
            }, type: type, multiline: multiline, rows: rows, sx: selectOptions.length > 0
                ? { ...inputStyled, ...selectStyled }
                : inputStyled, fullWidth: true, spellCheck: false, slotProps: {
                input: {
                    disableUnderline: true,
                    endAdornment: hasError ? inputAdornmentError : undefined,
                },
                htmlInput: {
                    "aria-required": !!rules?.required,
                    "aria-describedby": helperTextId,
                },
                formHelperText: {
                    id: helperTextId,
                },
            }, ...(selectOptions.length > 0 && { select: true }), children: selectOptions.length > 0 &&
                selectOptions.map((option) => (_jsx(MenuItem, { value: option.value, children: option.label }, option.value))) })) }));
};
export default ContactTextField;
